<div class="list-group list-group-flush list-group-scrollable">
	@if (!activeProject()) {
  	<ng-container *ngTemplateOutlet="listItem; context: { $implicit: {name: '' }, isActive: !activeProject() }"></ng-container>
	}
	<ng-container *ngFor="let prj of filteredProjectList(); let first = first">
    <ng-container *ngTemplateOutlet="listItem; context: { $implicit: prj, isActive: prj._id === activeProject() }"></ng-container>
  </ng-container>
</div>

<ng-template #listItem let-item let-isActive="isActive">
  <div class="list-group-item list-group-item-action flex-column align-items-start"
       [class.active]="isActive" (click)="selectProject.emit(item._id)">
    <div class="d-flex w-100 justify-content-between align-items-center">
      <div class="project-info">
        <span>{{ item.name || 'Kein ' + entityLabel.name + ' geladen' }}</span>
        @if (item._id && (item.owner || hasAnyMembers(item))) {
          <div class="project-members small text-muted">
            @if (item.owner) {
              <span class="me-2" title="Eigentümer"><i class="bi bi-person-fill"></i> {{ item.owner.username }}</span>
            }
            @for (role of rolesConfig.memberRoles; track role.field) {
              @if (item[role.field]?.length) {
                <span class="me-2" [title]="role.label"><i class="bi" [ngClass]="role.icon"></i> {{ formatMembers(item[role.field]) }}</span>
              }
            }
          </div>
        }
      </div>
      <div class="d-flex align-items-center">
        @let status = projectDownloadStatus().get(item._id) ?? 'none';
        @if (item._id && !isActive && statusInitialized()) {
          <i class="bi"
             [class.bi-cloud]="status === 'none'"
             [class.bi-cloud-download-fill]="status === 'partial'"
             [class.bi-cloud-check]="status === 'complete'"
             [class.bi-folder-x]="status === 'geodata_missing'"
             [class.text-danger]="status === 'partial' || status === 'geodata_missing'"></i>
        }
        @if (item._id && isActive && statusInitialized() && status === 'none' && !offlineActive()) {
          <div class="btn-group" ngbDropdown container="body">
            <button type="button" class="btn btn-outline-dark"
                    (click)="$event.stopPropagation()">
              <i class="bi bi-cloud"></i>
            </button>
            <button type="button" class="btn btn-outline-dark dropdown-toggle dropdown-toggle-split"
                    ngbDropdownToggle (click)="$event.stopPropagation()">
            </button>
            <div ngbDropdownMenu>
              <button ngbDropdownItem (click)="onProjectEdit($event)">Bearbeiten</button>
              <button ngbDropdownItem (click)="selectProject.emit('')">Schließen</button>
              @if (canCreateProjects) {
                <button ngbDropdownItem (click)="onProjectNew($event)">{{ entityLabel.newLabel }}...</button>
              }
              @if (canDeleteActiveProject) {
                <div class="dropdown-divider"></div>
                <button ngbDropdownItem class="text-danger" (click)="onProjectDelete($event)">Löschen</button>
              }
            </div>
          </div>
        }
        @if (item._id && isActive && statusInitialized() && status === 'geodata_missing' && !offlineActive()) {
          <!-- Geodaten fehlen: Öffne LayerStore statt Download -->
          <div class="btn-group" ngbDropdown container="body">
            <button type="button" class="btn btn-outline-dark"
                    (click)="openLayerStore(); $event.stopPropagation()"
                    title="Geodaten-Dateien fehlen">
              <i class="bi bi-folder-x text-danger"></i>
            </button>
            <button type="button" class="btn btn-outline-dark dropdown-toggle dropdown-toggle-split"
                    ngbDropdownToggle (click)="$event.stopPropagation()">
            </button>
            <div ngbDropdownMenu>
              <button ngbDropdownItem (click)="openLayerStore()">Geodaten wiederherstellen</button>
              <button ngbDropdownItem (click)="onDiscardOfflineData()">Offlinedaten verwerfen</button>
              <div class="dropdown-divider"></div>
              <button ngbDropdownItem (click)="onProjectEdit($event)">Bearbeiten</button>
              <button ngbDropdownItem (click)="selectProject.emit('')">Schließen</button>
              @if (canCreateProjects) {
                <button ngbDropdownItem (click)="onProjectNew($event)">{{ entityLabel.newLabel }}...</button>
              }
              @if (canDeleteActiveProject) {
                <div class="dropdown-divider"></div>
                <button ngbDropdownItem class="text-danger" (click)="onProjectDelete($event)">Löschen</button>
              }
            </div>
          </div>
        }
        @if (item._id && isActive && statusInitialized() && (status === 'partial') && !offlineActive()) {
          <div class="btn-group" ngbDropdown container="body">
            <button type="button" class="btn btn-outline-dark"
                    (click)="$event.stopPropagation()">
              <i class="bi bi-cloud-download-fill text-danger"></i>
            </button>
            <button type="button" class="btn btn-outline-dark dropdown-toggle dropdown-toggle-split"
                    ngbDropdownToggle (click)="$event.stopPropagation()">
            </button>
            <div ngbDropdownMenu>
              <button ngbDropdownItem (click)="onDiscardOfflineData()">Offlinedaten verwerfen</button>
              <div class="dropdown-divider"></div>
              <button ngbDropdownItem (click)="onProjectEdit($event)">Bearbeiten</button>
              <button ngbDropdownItem (click)="selectProject.emit('')">Schließen</button>
              @if (canCreateProjects) {
                <button ngbDropdownItem (click)="onProjectNew($event)">{{ entityLabel.newLabel }}...</button>
              }
              @if (canDeleteActiveProject) {
                <div class="dropdown-divider"></div>
                <button ngbDropdownItem class="text-danger" (click)="onProjectDelete($event)">Löschen</button>
              }
            </div>
          </div>
        }
        @if (item._id && isActive && statusInitialized() && status === 'complete' && !offlineActive()) {
          <div class="btn-group" ngbDropdown container="body">
            <button type="button" class="btn btn-outline-dark disabled"
                    [style.pointer-events]="'none'">
              <i class="bi bi-cloud-check text-success"></i>
            </button>
            <button type="button" class="btn btn-outline-dark dropdown-toggle dropdown-toggle-split"
                    ngbDropdownToggle (click)="$event.stopPropagation()">
            </button>
            <div ngbDropdownMenu>
              <button ngbDropdownItem (click)="onDiscardOfflineData()">Offlinedaten verwerfen</button>
              <div class="dropdown-divider"></div>
              <button ngbDropdownItem (click)="onProjectEdit($event)">Bearbeiten</button>
              <button ngbDropdownItem (click)="selectProject.emit('')">Schließen</button>
              @if (canCreateProjects) {
                <button ngbDropdownItem (click)="onProjectNew($event)">{{ entityLabel.newLabel }}...</button>
              }
              @if (canDeleteActiveProject) {
                <div class="dropdown-divider"></div>
                <button ngbDropdownItem class="text-danger" (click)="onProjectDelete($event)">Löschen</button>
              }
            </div>
          </div>
        }
        @if (item._id && isActive && statusInitialized() && status === 'geodata_missing' && offlineActive() && onlineAvailable()) {
          <!-- Im Offline-Modus: Nur LayerStore für lokale Geodaten, kein Download -->
          <button type="button" class="btn btn-outline-dark"
                  (click)="openLayerStore(); $event.stopPropagation()">
            <i class="bi bi-folder-x text-danger"></i>
          </button>
        }
        @if (item._id && isActive && statusInitialized() && status === 'partial' && offlineActive() && onlineAvailable()) {
          <!-- Im Offline-Modus: Partial-Status nur anzeigen, Download nicht möglich -->
          <i class="bi bi-cloud-download-fill text-danger"></i>
        }
        @if (item._id && isActive && statusInitialized() && status === 'complete' && offlineActive()) {
          <i class="bi bi-cloud-check text-success"></i>
        }
        @if (item._id && isActive && statusInitialized() && (status === 'partial' || status === 'geodata_missing') && offlineActive() && !onlineAvailable()) {
          <i class="bi"
             [class.bi-cloud-download-fill]="status === 'partial'"
             [class.bi-folder-x]="status === 'geodata_missing'"
             class="text-danger"></i>
        }
        <small [class.text-muted]="!isActive">{{ item.date | date:'shortDate' }}</small>
      </div>
    </div>
  </div>
</ng-template>

<!-- Loading-Overlay während Offline-Modus vorbereitet wird -->
@if (isPreparingOffline()) {
  <div class="preparing-overlay">
    <div class="preparing-content">
      <div class="spinner-border spinner-border-sm text-primary me-2" role="status">
        <span class="visually-hidden">Wird vorbereitet...</span>
      </div>
      <span>Bereite Offline-Modus vor...</span>
    </div>
  </div>
}
